<template>
  <d-modal v-if="showModal" style="background-color: rgba(0,0,0,0.6)!important;" class="patients-form-decisions">
    <button
      @click.prevent="closeModal"
      :class="['mr-1', 'decisions-close-button', show ? 'decisions-close-button-load' : 'decisions-close-button-hidden']">
      <i class="material-icons">close</i>
    </button>
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template>Dodawanie kolejnej rezerwacji</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer ref="visit-form-next-reservations" tag="form">
        <div class="form-group">
          <validation-provider
            :rules="'required'"
            :name="'service_id'"
            v-slot="{ errors }">
            <div class="form-group" style="margin-bottom: 1.8rem;">
              <label class="title-box" :for="data.service_id">
                Usługa:
              </label>
              <span class="ml-1" style="color: #c4183c">*</span>
              <v-select
                class="reservation-style reservation-style-select-mid"
                :options="services"
                v-model="data.service_id"
                :reduce="service => service.id"
                placeholder="Wybierz usługę..."
                label="name">
                <template #search="{attributes, events}">
                  <d-input
                    class="input-for-select"
                    :state="errors.length ? 'invalid' : null"
                    :required="!data.service_id"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name ? option.name : '' }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name ? option.name : '' }}
                  </div>
                </template>
              </v-select>
            </div>
            <div class="invalid-feedback" style="display: block; margin-top: -1.4rem;">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeModal">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div v-if="!services" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from '../../../utils/FormUtils.js';

export default {
  name: 'visits-form-reservation',
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data() {
    return {
      data: {
        service_id: ''
      },
      services: []
    };
  },
  props: {
    showModal: {
      type: Boolean
    },
    closeModal: {
      type: Function
    },
    refreshList: {
      type: Function
    },
    visitId: {
      type: [Number, String]
    },
    show: {
      type: Boolean
    },
  },
  mounted () {
    this.getServiceList();
  },
  methods: {
    getServiceList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/items?ignore_users_filters=1',
        outputKey: 'services',
        params: {
          pagination: false
        },
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['visit-form-next-reservations'], this.submitForm);
    },
    submitForm  () {
      let formDataToSend = {
        visit_id: this.visitId,
        service_id: this.data.service_id
      };
      let endpointUrl = 'patients/reservation-list/continue';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano rezerwację',
        successText: 'Wybrana rezerwacja została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje rezerwacji nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.closeModal();
        }
      });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '../../../assets/scss/patients-form-decisions.scss';
</style>
